import { NgModule } from '@angular/core';

import { LoginModule } from 'app/auth/login/login.module';
import { RegisterModule } from 'app/auth/register/register.module';
import { ForgotPasswordModule } from 'app/auth/forgot-password/forgot-password.module';
import { ResetPasswordModule } from 'app/auth/reset-password/reset-password.module';
import { LockModule } from 'app/auth/lock/lock.module';
import { MailConfirmModule } from 'app/auth/mail-confirm/mail-confirm.module';
import { StoreModule } from '@ngrx/store';
import * as fromAuth from './auth.reducer';

@NgModule({
    imports: [
        // Authentication
        LoginModule,
        RegisterModule,
        ForgotPasswordModule,
        ResetPasswordModule,
        LockModule,
        MailConfirmModule,
        StoreModule.forFeature('auth', fromAuth.reducer),
    ]
})
export class AuthModule
{

}
